import i18n from 'services/base/i18n';

export default {
  ok:         () => i18n.pgettext('Components|List History|Filter History|Direction Input', 'OK'),
  checkAll:   () => i18n.pgettext('Components|List History|Filter History|Direction Input', 'Select All'),
  uncheckAll: () => i18n.pgettext('Components|List History|Filter History|Direction Input', 'Unselect All'),
};
